
<c-app-recent
    icon      = "mdi-history"
    :tooltip  = "$t('navtop.recent.incident')"
    :loader   = "load"
    @selected = "onSelected"
>
    <template v-slot:title="{ item }">
        <div>
            {{ item.recent.incident.id }} - {{ item.recent.incident.typeName }}
        </div>

        <v-spacer />
        <div class="primary--text">
            {{  item.recent.incident.sites[0].customer.name }}
        </div>
        <c-clipboard-chip
            v-if = "item.recent.hasClipboardEntries"
            size = "xsmall"
        />
    </template>

    <template v-slot:subtitle="{ item }" >
        <div class="recent-subtitle">
            {{ item.incident.sites[0].street }}
        </div>
        <div class="recent-subtitle v-flex">
            <div>
                {{ item.incident.sites[0].zip }} {{ item.incident.sites[0].city }}
            </div>
            <v-spacer />
            <div style="float: right; font-size: 8pt; padding-top: 1px">
                {{ format(item.accesstime) }}
            </div>
        </div>
    </template>
</c-app-recent>
